// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red {\n  color: #f56c6c !important;\n  margin-left: 10px;\n}\n.tasting {\n  margin-top: 20px;\n}\n.title {\n  font-size: 16px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
